import { Radar } from "lucide-react";
import { useLang } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="border-t border-white/10 bg-[#080B12]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-3">
          <span className="inline-flex items-center justify-center w-8 h-8 rounded-sm border border-[#00E5FF]/40 bg-[#00E5FF]/5">
            <Radar
              size={16}
              strokeWidth={1.75}
              className="text-[#00E5FF]"
            />
          </span>
          <div>
            <div className="font-heading font-bold text-white text-sm tracking-tight">
              ITM<span className="text-[#00E5FF]">.</span>Consulting
            </div>
            <div className="font-mono text-[10px] uppercase tracking-widest text-slate-500">
              {t.footer.tagline}
            </div>
          </div>
        </div>

        <div className="text-xs font-mono uppercase tracking-widest text-slate-500 text-left md:text-right">
          <div>{t.footer.builtIn}</div>
          <div className="mt-1">
            © {year} ITM Consulting. {t.footer.rights}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
